import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function UserPreferencesAccountRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserPreferencesAccount', {
		url: '/preferences/my_account',
		controllerAs: 'vm',
		controller: UserPreferencesAccountCtrl,
		templateUrl: '/ng/hub/User/Preferences/Account/UserPreferencesAccountCtrl.html?' + window.BUILD,
		permission: ['login'],
		resolve: {
			$title: () => 'My Account',
			user: ApiResourcify.endpoint('/v3/users/me'),
			userAccess: ApiResourcify.endpoint('/users/me/access'),
			homePageSetting: ApiResourcify.endpoint('/config/search?code=Features.home_page'),
		},
	});
}

export class UserPreferencesAccountCtrl {
	constructor(Api, Identity, modal, notifications, user, userAccess, homePageSetting) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.Identity = Identity;
		this.modal = modal;
		this.notifications = notifications;
		// set up
		this.user = user;
		this.access = userAccess;
		this.homePageSetting = homePageSetting[0];
	}
}
